import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import AcademiaButton from '../../CommonComps/Buttons/AcademiaButton';
import AddCountryModal from '../../CommonComps/Modals/AddCountryModal';

const AddCountryAction = ({
  hasCreatePermission,
}: {
  hasCreatePermission: boolean;
}) => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // rendering add country action component here
  return (
    <div className='flex items-center justify-end'>
      <AcademiaButton
        title={
          !hasCreatePermission ? 'You do not have permissions!' : undefined
        }
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
        isDisabled={!hasCreatePermission}
      >
        Add Country
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <AddCountryModal handleModalClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </div>
  );
};

export default AddCountryAction;
